import { render, staticRenderFns } from "./Comp49t2.vue?vue&type=template&id=370e38dc&scoped=true&"
import script from "./Comp49t2.vue?vue&type=script&lang=js&"
export * from "./Comp49t2.vue?vue&type=script&lang=js&"
import style0 from "./Comp49t2.vue?vue&type=style&index=0&id=370e38dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370e38dc",
  null
  
)

export default component.exports